module.exports = __webpack_public_path__ + "static/media/018_neru.1078297b.gif";